import React from "react";
import { Trans } from "react-i18next";

import { useTranslation } from "lib/i18n/use-translation";

import { Card, NotEnoughData } from "../engagement/EngagementTab";
import type { EngagementView } from "../engagement/engagement-view";
import engagementStyles from "../engagement/engagement.module.scss";
import styles from "./engagement-redesign.module.scss";

const K = "admin:companyDashboard.engagement";

// Safari drops a list's role once its markers are styled away, so the ranking
// states it again; its visible numbers are decorative, so each rank is spoken.
const LIST = "list";

const Popular = ({
  popular,
  quarter,
  day,
}: {
  popular: EngagementView["popular"];
  quarter: string;
  day: string;
}) => {
  const { t } = useTranslation(["admin"]);
  return (
    <Card
      title={t(`${K}.popular.title`)}
      description={t(`${K}.popular.ranked`, { quarter })}
    >
      {popular === null ? (
        <NotEnoughData />
      ) : popular.top === null ? (
        <p className={engagementStyles["not-enough"]}>
          {t(`${K}.popular.none`)}
        </p>
      ) : (
        <>
          <p className={styles["values-note"]}>
            {t(`${K}.popular.valuesCumulative`, { date: day })}
          </p>
          <ol className={styles["ranks"]} role={LIST}>
            {popular.rows.map((row, index) => (
              <li key={`${index}-${row.title}`} className={styles["rank"]}>
                <span className={styles["rank-index"]} aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className={styles["rank-body"]}>
                  <span className={styles["rank-title"]} title={row.title}>
                    <span className={styles["visually-hidden"]}>
                      {`${index + 1}. `}
                    </span>
                    {row.title}
                  </span>
                  <span className={styles["rank-track"]} aria-hidden="true">
                    <span style={{ width: `${row.width * 100}%` }} />
                  </span>
                </span>
                <span className={styles["rank-minutes"]}>
                  {row.minutes}
                  <span className={styles["visually-hidden"]}>
                    {` ${t(`${K}.popular.minutesUnit`)}`}
                  </span>
                </span>
              </li>
            ))}
          </ol>
          <p className={styles["summary"]}>
            <Trans
              i18nKey={`${K}.popular.summary`}
              values={{
                title: popular.top.title,
                minutes: popular.top.minutes,
              }}
              components={{ strong: <strong /> }}
            />
          </p>
        </>
      )}
    </Card>
  );
};

export default Popular;
